type Env = "production" | "staging";

export const INTERCOM_TOUR_ENV: Env =
  import.meta.env.VITE_RELEASE_ENV === "production" ? "production" : "staging";

export const INTERCOM_BANNER_EXPIRY_DAYS = 3;

export const INTERCOM_BANNER_KEYS = {
  project: "projectBannerDismissed",
  geofence: "geofenceBannerDismissed",
  checkIn: "checkInBannerDismissed",
  planning: "planningBannerDismissed",
  userGroup: "userGroupBannerDismissed",
  user: "userBannerDismissed",
  department: "departmentBannerDismissed",
} as const;

const INTERCOM_BANNER_CONFIG = {
  staging: {
    tours: {
      dashboard: "577187",
      planning: "606820",
      project: "606849",
      user: "606886",
      geofence: "606907",
      department: "606922",
      userGroup: "606925",
      checkIn: "607637",
    },
    articles: {
      project: "11170385",
      user: "11170401",
      department: "11170412",
      planning: "11170418",
      geofence: "11382973",
      userGroup: "11388121",
      checkIn: "11388126",
    },
  },
  production: {
    tours: {
      dashboard: "540117",
      planning: "605137",
      project: "604469",
      user: "605136",
      geofence: "605138",
      department: "606432",
      userGroup: "606435",
      checkIn: "607131",
    },
    articles: {
      project: "4921143",
      user: "6348880",
      department: "4915788",
      planning: "6347530",
      geofence: "11173572",
      userGroup: "11174533",
      checkIn: "6348686",
    },
  },
} as const;

export const INTERCOM_TOURS = INTERCOM_BANNER_CONFIG[INTERCOM_TOUR_ENV].tours;
export const INTERCOM_ARTICLES =
  INTERCOM_BANNER_CONFIG[INTERCOM_TOUR_ENV].articles;
